import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Modal, Carousel } from 'react-bootstrap'
import { CoinComponent } from '../Gamification/CoinComponent'
import { useSelector } from 'react-redux'

const StyledModal = styled(Modal)`
  .modal-content {
    background: transparent;
    border: none;
  }
  h5 {
    background-color: #fff;
    text-align: center;
    padding: 24px;
    border-radius: 20px;
  }
  .carousel-control-next, 
  .carousel-control-prev {
    opacity: 1;
  }
  .carousel-control-prev {
    left: -10%;
  } 
  .carousel-control-next {
    right: -10%;
  }
`

export default function PosterModal({ galleryType, images, posterOpen, setPosterOpen }) {
  const { boothMissions } = useSelector((state) => state.booth)
  const [mission, setMission] = useState(null)
  
  useEffect(() => {
    setMission(boothMissions.find(ms => ms.mission_type === "image_gallery"))
  }, [boothMissions])

  return (
    <StyledModal
      show={posterOpen}
      onHide={()=>setPosterOpen(false)}
      aria-labelledby="images-modal"
      centered
      size={galleryType === "wallpaper" ? "lg" : "md"}
    > 
      { mission && <CoinComponent mission={mission} />}
      <Modal.Body>
        {images.length > 0 ?
          images.length > 1 ?
          <Carousel>
            {images.map((poster,index)=>(
              <Carousel.Item key={`poster-${index}`} interval={4000}>
                <img className="d-block" src={poster.url} alt={`poster-${index}`} width="100%" />
              </Carousel.Item>
            ))}
          </Carousel>
          :
          <img className="d-block w-100" src={images[0].url} alt="poster" />
          :
          <h5>No poster available.</h5>
        }
      </Modal.Body>
    </StyledModal>
  )
}
